import { IStore } from "../store";

export const getGroups = (store: IStore) => [...store.tag.groups, ...(store.tag.newGroups || [])];
export const getTags = (store: IStore) => store.tag.tags;